// src/components/MealList.js

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMeals, deleteMeal } from '../actions/mealActions';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Typography } from '@mui/material';

const dayNames = {
  0: "Duminică",
  1: "Luni",
  2: "Marți",
  3: "Miercuri",
  4: "Joi",
  5: "Vineri",
  6: "Sâmbătă"
};

const MealList = ({ onEdit }) => {
  const dispatch = useDispatch();
  const meals = useSelector((state) => state.meals.meals);

  useEffect(() => {
    dispatch(fetchMeals());
  }, [dispatch]);

  const handleDelete = (mealId) => {
    dispatch(deleteMeal(mealId));
  };

  if (!meals || meals.length === 0) {
    return <Typography>Nu există.</Typography>;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>ID</TableCell>
          <TableCell>Ziua</TableCell>
          <TableCell>Descriere</TableCell>
          <TableCell>Acțiuni</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {meals.map((meal) => (
          <TableRow key={meal.meal_id}>
            <TableCell>{meal.meal_id}</TableCell>
            <TableCell>{dayNames[meal.day_of_week] || meal.day_of_week}</TableCell>
            <TableCell>
              <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
                {meal.description}
              </pre>
            </TableCell>
            <TableCell>
              <Button variant="outlined" color="primary" onClick={() => onEdit(meal)}>
                Editează
              </Button>
              <Button variant="outlined" color="secondary" onClick={() => handleDelete(meal.meal_id)} style={{ marginLeft: '10px' }}>
                Șterge
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MealList;
